import axios from "axios"
import baseUrl from "./base"

const formApi = {
  fetchAllFormComponent: async (token) => {
    return await axios.get(`${baseUrl}/api/formComponent`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchDetLayananForm: async (token, data) => {
    return await axios.get(`${baseUrl}/api/layananForm/get?id_layanan=${data.id_layanan}&id_dokumen=${data.id_dokumen}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },


  getJenisPelaporan: async (token) => {
    return await axios.get(`${baseUrl}/api/jenisPelaporan/get`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeJenisPelaporanLayanan: async (token, data) => {
    return await axios.post(`${baseUrl}/api/jenisPelaporan/storePelaporanLayanan`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateJenisPelaporan: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/jenisPelaporan/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  deleteJenisPelaporanLayanan: async (token, id_jenis_pelaporan, id_layanan_dokumen) => {
    return await axios.delete(`${baseUrl}/api/jenisPelaporan/${id_jenis_pelaporan}/destroyPelaporanLayanan/${id_layanan_dokumen}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  }
}

export default formApi